
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shopifyResource]",
      function () {
        return require("private-next-pages/[shopifyResource].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shopifyResource]"])
      });
    }
  